var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPastTime = function SvgPastTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.05 2.5A7.508 7.508 0 0 0 3.333 10H1.842a.412.412 0 0 0-.292.708l2.325 2.334a.413.413 0 0 0 .592 0l2.325-2.334a.417.417 0 0 0-.3-.708H5c0-3.25 2.65-5.875 5.917-5.833 3.1.041 5.708 2.65 5.75 5.75a5.837 5.837 0 0 1-5.834 5.916A5.746 5.746 0 0 1 7.267 14.6a.829.829 0 0 0-1.1.067c-.35.35-.325.941.066 1.241a7.381 7.381 0 0 0 4.6 1.592 7.508 7.508 0 0 0 7.5-7.717c-.108-3.908-3.375-7.175-7.283-7.283zm-.425 4.167a.63.63 0 0 0-.625.625v3.066c0 .292.158.567.408.717l2.6 1.542c.3.175.684.075.859-.217a.631.631 0 0 0-.217-.858l-2.4-1.425V7.283a.628.628 0 0 0-.625-.616z",
    fill: "#58B847"
  })));
};
export default SvgPastTime;